import React from 'react'
import FormV2InfoTooltip from '../info-tooltip.component'

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const CheckboxV2Field = ({
    label,
    value,
    onChange,
    isRequired,
    isDisabled,
    aria,
    classes,
    styles,
    onBlur,
    onFocus,
    id,
    name,
    info,
    ...props
}) => {
    if (info) console.log(props?.fieldName, info)
    return (
        <div
            className={`formV2-field-input-checkbox-wrapper ${classes?.field || ''}`}
            style={styles?.field}
        >
            <label
                htmlFor={id}
                className={isDisabled ? 'formV2-field-input-checkbox-label-disabled' : undefined}
            >
                <input
                    id={id}
                    type='checkbox'
                    checked={value || false}
                    onChange={e => onChange?.(e.target.checked)}
                    required={isRequired}
                    disabled={isDisabled}
                    {...aria || {}}
                    autoFocus={false}
                    name={name}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
                <span aria-hidden='true' className='formV2-field-input-checkbox-checkmark' />
                {label?.translate(lang)}

                {info ? <FormV2InfoTooltip info={info} className={classes?.info} style={styles?.info} /> : null}
            </label>
        </div>
    )
}

export default CheckboxV2Field